import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import EmailCampaignTemplatesAPI from '../../api/emailCampaignTemplates';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getEmailCampaignTemplates(_state) {
    return _state.records.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
  },
  getEmailCampaignTemplateById: _state => id =>
    _state.records.find(t => t.id === Number(id)),
};

export const actions = {
  get: async ({ commit }, params = {}) => {
    commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isFetching: true });
    try {
      const response = await EmailCampaignTemplatesAPI.list(params);
      commit(types.SET_EMAIL_CAMPAIGN_TEMPLATES, response.data);
    } catch (error) {
      // ignore
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isFetching: false });
    }
  },
  create: async ({ commit }, payload) => {
    commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isCreating: true });
    try {
      const response = await EmailCampaignTemplatesAPI.create(payload);
      commit(types.ADD_EMAIL_CAMPAIGN_TEMPLATE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isCreating: false });
    }
  },
  update: async ({ commit }, { id, ...payload }) => {
    commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isUpdating: true });
    try {
      const response = await EmailCampaignTemplatesAPI.update(id, payload);
      commit(types.EDIT_EMAIL_CAMPAIGN_TEMPLATE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isUpdating: false });
    }
  },
  delete: async ({ commit }, id) => {
    commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isDeleting: true });
    try {
      await EmailCampaignTemplatesAPI.delete(id);
      commit(types.DELETE_EMAIL_CAMPAIGN_TEMPLATE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG, { isDeleting: false });
    }
  },
  apply: async (_, { id, emailCampaignId }) => {
    const response = await EmailCampaignTemplatesAPI.apply(id, {
      emailCampaignId,
    });
    return response.data;
  },
};

export const mutations = {
  [types.SET_EMAIL_CAMPAIGN_TEMPLATE_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.ADD_EMAIL_CAMPAIGN_TEMPLATE]: MutationHelpers.create,
  [types.SET_EMAIL_CAMPAIGN_TEMPLATES]: MutationHelpers.set,
  [types.EDIT_EMAIL_CAMPAIGN_TEMPLATE]: MutationHelpers.update,
  [types.DELETE_EMAIL_CAMPAIGN_TEMPLATE]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
